var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"success"}},[_c('van-icon',{attrs:{"name":"checked","color":"#07C180","size":"50"}}),_c('h5',[_vm._v("绑定成功！")]),_c('h5',{on:{"click":function($event){return _vm.init()}}},[_vm._v("请重新登录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }